import { Injectable } from '@angular/core';
import { FormComponentType } from '@gs/shared';
import { ConfigModel, GsStructComponent } from '../../models';
import { TEXT_FIELD_COMPONENT_SCHEMA } from '../../schemas/components/form/text-field.schema';
import { BasicComponentDefinition, ComponentsHelper } from './components.service';

export type FormComponentGroup = 'basic';

export interface FormComponentDefinition extends BasicComponentDefinition<FormComponentGroup> {
  /** Is this component still in development and shouldnt be used yet? (Disabled for adding newly into pages, components already on page will work) */
  wip?: boolean;
  /** The group in wich the component should get displayed */
  group: 'basic';
}

@Injectable({
  providedIn: 'root'
})
export class FormComponentsHelper extends ComponentsHelper<FormComponentType, FormComponentDefinition, FormComponentGroup> {
  /** The components to display in the sidemenu */
  override components: Record<FormComponentType, FormComponentDefinition> = {
    Text: {
      name: 'formComponents.text.name',
      group: 'basic',
      iconName: 'text-t',
      iconWeight: 'regular',
      loadComponent: () => import('../../components/gs-form/input-types/gs-text/gs-text.component').then((m) => m.GsTextFormComponent),
      formSchema: TEXT_FIELD_COMPONENT_SCHEMA,
      bcModules: ['*', 'website']
    }
  };
  /** The translation prefix for the groups of the components, to display the groupnames in the right language */
  override groupTranslationPrefix: string = 'formComponents.groups.';
  /** The priority of the groups to display them in the right order in the sidemenu (lower number = higher priority) */
  override groupPriorities = {
    basic: 1
  };

  /**
   * Get the default settings for a component
   * @param type of the component
   * @param config the config to get the default settings from
   * @returns the default settings for the component
   */
  getComponentDefaultSettings(_type: FormComponentType, _config?: ConfigModel): GsStructComponent<unknown> | undefined {
    return undefined;
  }
}
